import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, CardWithLable } from "@public/ui-toolkit";
import debounce from "lodash/debounce";
import { getStageAllocators } from "./actions";
import { useHistory } from "react-router-dom";
import { Col, Row, Progress, Table } from 'antd';
import ReactDropDown from "@public/ui-toolkit/src/ReactSelect";
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "180px",
    backgroundColor: "#3ac1b5",
    border: "#3ac1b5",
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    height: "100%",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#fff",
  }),
  singleValue: (provided) => ({ ...provided, color: "#fff" }),
  input: (styles) => ({ ...styles, color: "#fff" }),
};
const stageAllocation = [
  {
    title: "Stage 1 : General Interest",
    key: 0,
  },
  {
    title: "Stage 2 : Introductory Virtual Meeting",
    key: 1,
  },
  {
    title: "Stage 3 : In Depth Meeting",
    key: 2,
  },
  {
    title: "Stage 4 : Due Diligence",
    key: 3,
  },
  {
    title: "Stage 5 : Allocation",
    key: 4,
  },
];

const stageAllocationDropDown = [
  {
    title: "All",
    key: null,
  },
  {
    title: "Stage 1 : General Interest",
    key: 0,
  },
  {
    title: "Stage 2 : Introductory Virtual Meeting",
    key: 1,
  },
  {
    title: "Stage 3 : In Depth Meeting",
    key: 2,
  },
  {
    title: "Stage 4 : Due Diligence",
    key: 3,
  },
  {
    title: "Stage 5 : Allocation",
    key: 4,
  },
];

const StageAllocation = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [stageValue, setStageValue] = useState(null);

  const [paginationInfo, setPaginationInfo] = useState({
    page: 1,
    perPage: 10,
  });

  const myStageAllocation = useSelector((state) => state.StageAllocationStore);

  const { stageAllocators, rows } = myStageAllocation;

  const handleSearch = debounce((text) => {
    setSearch(text);
  }, 1000);

  const handleStage = debounce((val) => {
    setStageValue(val);
  }, 500);

  useEffect(() => {
    setPaginationInfo({ ...paginationInfo, page: 1 });
    const payload = {
      keyword: search,
      stage: stageValue?.value,
      page: 1,
      perPage: paginationInfo.perPage,
      SortBy : 1,
      SortByColumn : "Stage"
    };
    dispatch(getStageAllocators(payload));
  }, [search, stageValue, dispatch]);


  const StagePercentage = (stage) => {
    return (stage + 1) * 100 / 5;
  }

  const columns = [
    {
      title: "Allocator",
      dataIndex: "allocatorName",
      key : "allocatorName",
      sorter : true
    },
    {
      title: "Current Stage",
      sorter: true,
      dataIndex: "stage",
      key : "stage",
      render: (item) => {
        return (
          <>{stageAllocation[item]?.title}</>
        )
      },
    },
    {
      title: "Progress",
      sorter: true,
      dataIndex: "stage",
      key : "stage",
      render: (item) => {
        return (
          <Progress steps={5} percent={StagePercentage(item)} format={() => ""} />
        )
      },
    },
  ];

  const onChange = (pagination, filters, sorter, extra) => {
    if (Object.keys(sorter).length > 0 && extra.action === "sort") {
        pagination.current = 1;
        setPaginationInfo({ ...paginationInfo, page: pagination?.current });
    }else{
      setPaginationInfo({ ...paginationInfo, page: pagination?.current });
    }

    const payload = {
      keyword: search,
      stage: stageValue?.value,
      page: pagination.current,
      perPage: paginationInfo.perPage,
      SortBy :sorter.order === "ascend" ? 1 : 2,
      SortByColumn : Object.keys(sorter).length > 0 ? sorter?.field === "stage" ? "Stage" : "AllocatorName" : "CreationTime"
    };
    dispatch(getStageAllocators(payload));
  };

  return (
    <div>
      <main>
        <div className="main-inner mt-4">
          <div className="mr-4 ml-4">
            <div>
              <h2 className="text-center">Allocator Insight</h2>
            </div>
            <form className="mt-3 mb-3">
              <Row gutter={[24, 24]}>
                <Col span={8} offset={6}>
                  <Input
                    defaultValue={search}
                    placeholder="Search"
                    label="Search"
                    type="text"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </Col>
                <Col span={4} style={{ zIndex : "9" }}>
                  <ReactDropDown
                    styles={customStyles}
                    placeholder="Select a Stage"
                    selectedValue={
                      stageValue != null
                        ? {
                          value: stageValue?.value,
                          label: stageValue?.label
                        }
                        : { value: "Select a Stage", label: "Select a Stage" }
                    }
                    onChange={(e) => {
                      handleStage(e)
                    }}
                    performanceMetrcisResult={stageAllocationDropDown.map((stage) => {
                      return ({ value: stage.key, label: stage.title })
                    })}
                  />
                </Col>
              </Row>
            </form>
            {/* {loading ? (
              <Spinner className="text-center" />
            ) : ( */}
              <div
                className="
            edit-profile-container
            p-xxl-5 p-md-4 p-3
            box-shadow
            bg-white
            rounded-large
            mt-2
          "
              >
                <CardWithLable title={"Allocator Insight"}>
                  <div className="hf-card2-body px-0 pb-0">
                    <div className="hf-table">
                      <Table
                        onRow={(record, rowIndex) => {
                          return {
                            onClick: (event) => {
                              return history.push(`/allocator?allocatorId=${record.allocatorId}`);
                            }
                          };
                        }}
                        pagination={{
                          total : rows,
                          current : paginationInfo.page,
                        }}
                        columns={columns}
                        dataSource={stageAllocators}
                        onChange={onChange} />
                    </div>
                  </div>
                </CardWithLable>
              </div>
            {/* )} */}
          </div>
        </div>
      </main>
    </div>
  );
};

export default StageAllocation;
